export default __webpack_public_path__ + "static/media/a-noite-no-castelo.bf9f3f10.mp3";